import React, { useState, useEffect, useCallback, memo } from 'react';
import {
  Star,
  StarFilled,
  CloseIconWMO,
  SparkAIChatIcon,
} from '@usap/uicomponents';
import {
  Overlay,
  ModalContainer,
  StarsRow,
  CloseBtn,
  Button,
  FlexContainer,
  ThankYouText,
} from './style/AIChatFeedbackModal.css';
import apiConfig from '../../../../carparts/src/config/api-config';
import axios from 'axios';

const AIChatFeedbackModal = ({ content }) => {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [sessionId, setSessionId] = useState('');

  const getLocalStorageItem = (key) => {
    if (typeof window !== 'undefined') {
      const data = localStorage.getItem(key);
      if (data) {
        try {
          return JSON.parse(data);
        } catch {
          return {};
        }
      }
    }
    return {};
  };

  const onClose = () => setFeedbackOpen(false);

  const onSubmit = async (rating) => {
    setSelectedRating(rating);
    setIsSubmitting(true);
    try {
      const apiUrlAuth = `${apiConfig.chatbotServiceAPIURL}/spark/rating_update`;
      if (!sessionId) {
        onClose();
        return;
      }
      const body = {
        session_id_rating: sessionId,
        rating_rating: rating,
      };
      await axios.post(apiUrlAuth, body, {
        headers: { apikey: apiConfig.apiKey },
      });
      setFeedbackSubmitted(true);
    } catch (error) {
      console.error('Failed to submit feedback rating', error);
      setFeedbackOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('redirectFrom') === 'chat') {
      const CHAT_SESSION_ID_KEY = 'carparts_chat_session';
      const storedSessionData = getLocalStorageItem(CHAT_SESSION_ID_KEY);

      if (!storedSessionData.sessionId) return;

      setSessionId(storedSessionData.sessionId);
      setFeedbackOpen(true);
    }
  }, []);

  if (!feedbackOpen || !content) return null;

  return (
    <>
      <ModalContainer>
        <CloseBtn aria-label="Close" onClick={onClose}>
          <CloseIconWMO width="24px" height="24px" />
        </CloseBtn>
        <FlexContainer>
          <div>
            <SparkAIChatIcon width="48" height="48" />
          </div>
          <div>
            <h1>{content.heading}</h1>
            <h2>{content.subHeading}</h2>
          </div>
        </FlexContainer>
        {feedbackSubmitted ? (
          <ThankYouText>
            {content.thankYouText}
          </ThankYouText>
        ) : (
          <StarsRow>
            <div>
              {[1, 2, 3, 4, 5].map((n) => (
                <Button
                  key={n}
                  aria-label={`Rate ${n} star`}
                  onClick={() => onSubmit(n)}
                  disabled={isSubmitting}
                >
                  {selectedRating >= n ? <StarFilled /> : <Star />}
                </Button>
              ))}
            </div>
            <div>
              <p>{content.ratingLabelOne}</p>
              <p>{content.ratingLabelTwo}</p>
            </div>
          </StarsRow>
        )}
      </ModalContainer>
      <Overlay />
    </>
  );
};

export default memo(AIChatFeedbackModal);
